<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Sub Categories</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-sub-category">
            <v-icon left dark>mdi-plus</v-icon>New Sub Category
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="5" md="5">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="subCategories"
              :search="search"
            >
             <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/sub-category/${item.id}`" icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Name", value: "Name" },
      { text: "Action", value: "action" }
      ],
    subCategories: [],
  }),
  methods: {
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/sub-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.subCategories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created () {
    this.getCategories();
  },
};
</script>